export const strongCopyData = (data: any) => data && JSON.parse(JSON.stringify(data));
